import { createMultiPartFormBody } from "../util/Util";
import { ApiKey, ApiUrl, WebUrl } from "../util/Constant";
import {
	showResponseMessage,
	_SET_RESET_PASSWORD,
	_BIND_MEMBER,
	_BIND_MEMBER_WALLET_BALANCE,
	userKeepLogin,
	bindGames,
	bindHotGames,
	bindMember,
} from "./AppAction";
import ApiEngine from "../util/ApiEngine.js";
import { _SAVE_LANGUAGE_ID } from "./LanguageAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { mergeAndFlushClientErrorLogs } from "../util/ClientLogger";
import {
	clearFavouriteGames,
	syncFavouriteGamesOnLogin,
} from "../util/favouriteGamesStorage";

export const _LOGIN_SUCCESS = "LoginSuccess";
export const _LOGIN_FAILED = "LoginFailed";
export const _LOGOUT = "Logout";
export const _GET_SHOP_CREDIT = "GetShopCredit";
export const _UPDATE_USER_DATA = "UpdateUserData";
export const _LOGIN_MODAL = "LoginModal";
export const _TRIGGER_PARALLEL_LOGIN_REDIRECT = "triggerParallelLoginRedirect";


/// <summary>
/// Author :
/// expose login action as function to be called from classes
/// </summary>
export function performLogin(
	username,
	password,
	selectedLanguage
) {
	return async (dispatch, getState) => {
		await dispatch(resetLogin());

		let params = {
			username: username,
			password: password,
			selectedLanguage: selectedLanguage,
		};

		var responseJson = await ApiEngine.post(
			ApiUrl._API_LOGIN,
			createMultiPartFormBody(params)
		);

		if (responseJson[ApiKey._API_SUCCESS_KEY]) {
			var userData = responseJson[ApiKey._API_DATA_KEY]["userData"];
			if (window.ReactNativeWebView) {
				window.ReactNativeWebView.postMessage(
					JSON.stringify({
						action: "login",
						jwtToken: responseJson[ApiKey._API_DATA_KEY]["jwtToken"],
						userId: userData["userId"],
					})
				);
			}
			
			dispatch({
				type: _LOGIN_SUCCESS,
				userData: userData,
			});
			await bindMember(dispatch);
			await syncFavouriteGamesOnLogin(getState()?.appState?.member?.id);
		} else {
			dispatch({
				type: _LOGIN_FAILED,
				message: responseJson[ApiKey._API_MESSAGE_KEY],
			});
			dispatch(
				showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY])
			);
		}
	};
}

export function performLoginReturnMessage(
	username,
	password,
	selectedLanguage,
	isKeepedLogin,
	isLoginAttemptBlockingEnabled,
	loginCaptcha,
	existingLoginTicket
) {
	return async (dispatch, getState) => {
		await dispatch(resetLogin());

		dispatch(userKeepLogin(isKeepedLogin));
		let params = {
			username: username,
			password: password,
			isKeepedLogin: isKeepedLogin,
			selectedLanguage: selectedLanguage,
			isLoginAttemptBlockingEnabled: isLoginAttemptBlockingEnabled,
			loginCaptcha: loginCaptcha || ""
		};
		if (existingLoginTicket !== undefined) {
			if (!existingLoginTicket) {
				return { type: _LOGIN_FAILED, message: "LOGIN_EXPIRED", captchaRequired: true };
			}
			params.loginTicket = existingLoginTicket;
		}

		var responseJson = await ApiEngine.post(
			ApiUrl._API_LOGIN,
			createMultiPartFormBody(params)
		);

		if (responseJson[ApiKey._API_SUCCESS_KEY]) {
			var userData = responseJson[ApiKey._API_DATA_KEY]["userData"];
			if (window.ReactNativeWebView) {
				window.ReactNativeWebView.postMessage(
					JSON.stringify({
						action: "login",
						jwtToken: responseJson[ApiKey._API_DATA_KEY]["jwtToken"],
						userId: userData["userId"],
					})
				);
			}

			dispatch({
				type: _LOGIN_SUCCESS,
				userData: userData,
			});
			await bindMember(dispatch);
			await syncFavouriteGamesOnLogin(getState()?.appState?.member?.id);
			dispatch({
				type: _SET_RESET_PASSWORD,
				isResetPassword: userData["isResetPassword"],
			});
				
			return {
				type: _LOGIN_SUCCESS,
				message: _LOGIN_SUCCESS
			}
		} else {
			dispatch({
				type: _LOGIN_FAILED,
				message: responseJson[ApiKey._API_MESSAGE_KEY],
			});
			return {
				type: _LOGIN_FAILED,
				message: responseJson[ApiKey._API_MESSAGE_KEY],
				captchaRequired: !!responseJson.captchaRequired
			}
		}
	};
}

export function performGoogleLoginReturnMessage(
	credential,
	selectedLanguage,
	isKeepedLogin,
	extraParams = {}
) {
	return async (dispatch, getState) => {
		await dispatch(resetLogin());

		dispatch(userKeepLogin(isKeepedLogin));
		let params = {
			credential,
			isKeepedLogin,
			selectedLanguage,
			...extraParams,
		};

		var responseJson = await ApiEngine.post(
			ApiUrl._API_GOOGLE_LOGIN,
			createMultiPartFormBody(params)
		);

		if (responseJson[ApiKey._API_SUCCESS_KEY]) {
			var userData = responseJson[ApiKey._API_DATA_KEY]["userData"];
			if (window.ReactNativeWebView) {
				window.ReactNativeWebView.postMessage(
					JSON.stringify({
						action: "login",
						jwtToken: responseJson[ApiKey._API_DATA_KEY]["jwtToken"],
						userId: userData["userId"],
					})
				);
			}

			dispatch({
				type: _LOGIN_SUCCESS,
				userData: userData,
			});
			await bindMember(dispatch);
			await syncFavouriteGamesOnLogin(getState()?.appState?.member?.id);
			dispatch({
				type: _SET_RESET_PASSWORD,
				isResetPassword: userData["isResetPassword"],
			});

			return {
				type: _LOGIN_SUCCESS,
				message: _LOGIN_SUCCESS,
				isNew: !!responseJson[ApiKey._API_DATA_KEY]["isNew"],
			};
		} else {
			dispatch({
				type: _LOGIN_FAILED,
				message: responseJson[ApiKey._API_MESSAGE_KEY],
			});
			return {
				type: _LOGIN_FAILED,
				message: responseJson[ApiKey._API_MESSAGE_KEY],
				isNew: false,
			};
		}
	};
}
/// <summary>
/// Author :
/// this function is to only update user status to login if it is already considered authenticated in cookie
/// </summary>
export const updateLoginUser = (userData) => {
	return {
		type: _LOGIN_SUCCESS,
		userData: userData,
	};
};

export const updateWalletBalance = (userData) => {
	return {
		type: _BIND_MEMBER_WALLET_BALANCE,
		walletBalance: userData.walletBalance + userData.bonusBalance,
		walletsDetails: {
			currentWalletBalance: userData.walletBalance,
			bonusWalletBalance: userData.bonusBalance,
			isPromoCleared: userData.isPromoCleared,
			isBonusWalletRestored: userData.isBonusWalletRestored,
			isValidForPromotion: userData.isAnyTransactionValidForPromo,
			isActivedPromoExist: userData.isActivedPromoExist,
			promoMaxWithdrawal: userData.promoMaxWithdrawal,
			minCoinTarget: userData.minCoinTarget,
			promotionName: userData.promotionName,
			promoRolloverBalance: userData.promoRolloverBalance,
			promoRolloverTarget: userData.promoRolloverTarget,
			isFreeGGRPromo: userData.isFreeGGRPromo,
			forceWithdraw: userData.forceWithdraw,
			memberProductBalanceList: userData.memberProductBalanceList,
			promoExpiresAt: userData.promoExpiresAt || null,
		},
		rolloverDetails: userData.rolloverDetails,
		vipProgress: {
			vipId: userData.vipId,
			name: userData.vipName,
			targetName: userData.targetName,
			vipUpgradeValidTurnover: userData.vipUpgradeValidTurnover,
			membershipUpgradeBalance: userData.membershipUpgradeBalance,
			targetObtainCriteriaMode: userData.targetObtainCriteriaMode,
			targetObtainMinBet: userData.targetObtainMinBet,
			targetObtainDeposit: userData.targetObtainDeposit,
			isMaxLevel: userData.isMaxLevel,
		},
	};
};



/// <summary>
/// Author :
/// </summary>
export const updateUserData = (userData) => {
	return async (dispatch) => {
		// var responseJson = await ApiEngine.get(ApiUrl._API_REFRESH_USER_DATA);
		// if (responseJson[ApiKey._API_SUCCESS_KEY]) {
			dispatch({
				type: _UPDATE_USER_DATA,
				// userData: responseJson[ApiKey._API_DATA_KEY],
				userData: userData
			});
		// }
	};
};

/// <summary>
/// Author :
/// expose logout action as function to be called from classes
/// </summary>
export const performLogout = () => {
	return async (dispatch) => {
		var responseJson = await ApiEngine.post(ApiUrl._API_LOGOUT);

		await responseJson;
		if (window.ReactNativeWebView) {
			window.ReactNativeWebView.postMessage(
				JSON.stringify({ message: "Succesfully logged out.", code: "LOGOUT" })
			);
		}
		
		await dispatch(resetLogin());

		dispatch({
			type: _BIND_MEMBER,
			member: [],
			walletBalance: 0,
			walletsDetails: {
				currentWalletBalance: 0,
				bonusWalletBalance: 0,
				isPromoCleared: false,
				isBonusWalletRestored: false,
				isValidForPromotion: false,
				isActivedPromoExist: false,
				promoMaxWithdrawal: 0,
				minCoinTarget: 0,
				promotionName:"",
				promoRolloverBalance:0,
				promoRolloverTarget:0,
				isFreeGGRPromo: false,
				forceWithdraw: false,
				promoExpiresAt: null,
			},
			rolloverDetails: []


		});
	};
};

/// <summary>
/// Author :
/// this function is to only update user status to logout
/// </summary>
export const resetLogin = () => {
	return async (dispatch, getState) => {
		clearFavouriteGames(getState()?.appState?.member?.id);
		resetGameStates(dispatch);

		dispatch({
			type: _LOGOUT,
		});
	};
};

const resetGameStates = (dispatch) => {
	// CHRIS 20251111: Reset game states on login/logout so that we can update disabled games
	dispatch(bindGames([]));
	//dispatch(bindHotGames([]));
}

export const forceLogout = (msg = "FORCED_LOGOUT") => {
	return async (dispatch) => {
		resetGameStates(dispatch);

		await ApiEngine.post(ApiUrl._API_LOGOUT); // Executes DelCookies() on backend
		localStorage.removeItem("isOnload");
		dispatch(showResponseMessage(false, msg, true));
	
		await dispatch(resetLogin());

		if(msg == "FORCED_LOGOUT"){
			// Trigger the parallel login redirect (app.jsx)
			await dispatch(triggerParallelLoginRedirect(true));
		}
		
	};
};

export const triggerParallelLoginRedirect = (shouldRedirect) => {
	return async (dispatch) => {
		dispatch({
			type: _TRIGGER_PARALLEL_LOGIN_REDIRECT,
			payload: shouldRedirect
		})
	}
};

/// <summary>
/// Author : -
/// </summary>
export const heartBeat = () => {
	return async (dispatch, getState) => {
		var responseJson = await ApiEngine.get(ApiUrl._API_IS_LOGGED_IN); //, createMultiPartFormBody(params));

		await dispatch(handleHeartbeatResponse(responseJson));
	};
};

export const handleHeartbeatResponse = (responseJson) => {
	console.log('handleHeartbeatResponse')

	return async (dispatch, getState) => {
		if (responseJson[ApiKey._API_SUCCESS_KEY]) {
			var data = responseJson[ApiKey._API_DATA_KEY];
			// Check if promotion has changes
			const state = getState();
			if(state.authState.userData.isActivedPromoExist != data.isActivedPromoExist){
				// console.log('Promo changes detected: resetting game states')
				resetGameStates(dispatch);
			}

			dispatch(updateWalletBalance(data));
			dispatch(updateLoginUser(data));

			const trackUntil = new Date(responseJson[ApiKey._API_DATA_KEY].trackClientErrorsUntil).getTime();
			if (trackUntil > Date.now()) {
				mergeAndFlushClientErrorLogs();
			}
		} else if (
			!responseJson[ApiKey._API_SUCCESS_KEY] &&
			responseJson[ApiKey._API_MESSAGE_KEY] == "FORCED_LOGOUT"
		) {
			dispatch(forceLogout());
		} else if (
			!responseJson[ApiKey._API_SUCCESS_KEY] &&
			responseJson[ApiKey._API_MESSAGE_KEY] == "INVALID_ACCOUNT_STATUS"
		) {
			dispatch(forceLogout("INVALID_ACCOUNT_STATUS"));
		}else {
			dispatch(resetLogin());
		}
	};
}

export const setToggleLoginModal = (isToggleLoginModal) => {
	return (dispatch) => {
		dispatch({
			type: _LOGIN_MODAL,
			isToggleLoginModal: isToggleLoginModal,
		});
	};
};
